<script setup lang="ts">
import IrisSidebar from '@/Components/IrisSidebar.vue'
import { getStyles } from "@/Composables/styles";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import Image from "@common/Components/Image.vue"
import { inject, ref, onMounted, defineAsyncComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGalaxy } from "@fas/faGalaxy";import { faTimesCircle } from "@fas/faTimesCircle";import { faUserCircle } from "@fas/faUserCircle";
import { faBaby } from "@fal/faBaby";import { faShoppingCart as falShoppingCart } from "@fal/faShoppingCart";import { faCactus } from "@fal/faCactus";import { faObjectGroup } from "@fal/faObjectGroup";import { faUser } from "@fal/faUser";import { faHouse } from "@fal/faHouse";import { faTruck } from "@fal/faTruck";import { faTag } from "@fal/faTag";import { faPhone } from "@fal/faPhone";import { faUserCircle as falUserCircle } from "@fal/faUserCircle";import { faBars } from "@fal/faBars";
import { faBackpack } from "@far/faBackpack";import { faTruckLoading } from "@far/faTruckLoading";import { faTruckMoving } from "@far/faTruckMoving";import { faTruckContainer } from "@far/faTruckContainer";import { faUser as faUserRegular } from "@far/faUser";import { faWarehouse } from "@far/faWarehouse";import { faWarehouseAlt } from "@far/faWarehouseAlt";import { faShippingFast } from "@far/faShippingFast";import { faInventory } from "@far/faInventory";import { faDollyFlatbedAlt } from "@far/faDollyFlatbedAlt";import { faBoxes } from "@far/faBoxes";import { faShoppingCart } from "@far/faShoppingCart";import { faBadgePercent } from "@far/faBadgePercent";import { faChevronRight } from "@far/faChevronRight";import { faCaretRight } from "@far/faCaretRight";import { faPhoneAlt } from "@far/faPhoneAlt";import { faGlobe } from "@far/faGlobe";import { faPercent } from "@far/faPercent";import { faPoundSign } from "@far/faPoundSign";import { faClock } from "@far/faClock";





















import { faLambda } from "@fad/faLambda";
import { retinaLayoutStructure } from '@/Composables/useRetinaLayoutStructure'
import { computed } from 'vue'
import LinkIris from '@/Iris/Components/LinkIris.vue'
const IrisSearchMobile = defineAsyncComponent(() => import('@/Iris/Components/IrisSearchMobile.vue'))
import { urlLoginWithRedirect } from '@/Composables/urlLoginWithRedirect'

// Add icons to the library
library.add(
    faTimesCircle, faUser, faCactus, faBaby, falShoppingCart, faObjectGroup, faGalaxy, faLambda, faBackpack, faHouse, faTruck, faTag, faPhone, faBars,
    faTruckLoading, faTruckMoving, faTruckContainer, faUserRegular, faWarehouse, faWarehouseAlt, faShippingFast, faInventory, faUserCircle,
    faDollyFlatbedAlt, faBoxes, faShoppingCart, faBadgePercent, faChevronRight, faCaretRight, faPhoneAlt, faGlobe, faPercent, faPoundSign, faClock, falUserCircle
);


const props = defineProps<{
    headerData: {
        logo: {
            properties: object
            image: {
                source: Object
            }
            alt: string
        }
    },
    menuData: Object
    productCategories: Array<any>
    screenType?: 'mobile' | 'tablet' | 'desktop'
}>()

// console.log('-- Header data', props)
const layout = inject('layout', retinaLayoutStructure)
const isLoggedIn = inject('isPreviewLoggedIn', false)
// const isLoggedIn = false
const sidebarMenu = inject('sidebarMenu', null) // come from layout PreviewLayout (workshop), will null if in Iris

const computedSelectedSidebarData = computed(() => {
    return sidebarMenu?.value || layout.iris?.sidebar
})

const screenType = inject('screenType', 'desktop')

// Method: to remove fontSize from properties
const getStylesRemoveFontSize = (properties, screenType) => {
    const xxx = { ...getStyles(properties, screenType) }
    delete xxx?.fontSize

    return xxx
}
</script>

<template>
    <div id="mobile-header" class="block md:hidden p-3">
        <div class="grid grid-cols-3 items-center justify-between">
            <!-- Section: Hamburger & Search -->
            <div class="flex items-center gap-x-1 w-fit">
                <!-- Hamburger Sidebar -->
                <IrisSidebar
                    :header="headerData"
                    :menu="menuData"
                    :productCategories="productCategories"
                    :screenType="screenType"
                    :sidebarLogo="computedSelectedSidebarData?.data?.fieldValue?.sidebar_logo"
                    :sidebar="computedSelectedSidebarData"
                    
                >
                    <template #icon>
                        <FontAwesomeIcon
                            :icon="headerData?.mobile?.menu?.icon || 'fal fa-bars'"
                            :style="getStylesRemoveFontSize(headerData?.mobile?.menu?.container?.properties, screenType)"
                            fixed-width
                            aria-hidden="true"
                            class="text-3xl"
                        />
                    </template>
                </IrisSidebar>

                <!-- Search Bar -->
                <IrisSearchMobile
                    v-if="screenType !== 'desktop'"
                    id="iris_search_mobile"
                    :style="{
                        ...getStyles(headerData?.mobile?.profile?.container?.properties, screenType),
                    }"
                    class="text-3xl"
                />
            </div>

            <!-- Section: Logo -->
            <div class="xcol-span-2 flex items-center w-full" :class="layout.retina?.type == 'b2b' ? 'justify-start' : 'justify-center'">
                <component :is="LinkIris" :href="'/'" class="block h-[50px] w-full max-w-32">
                    <Image v-if="headerData.logo?.image?.source" :src="headerData.logo?.image?.source" alt="logo"
                        :imgAttributes="{ loading: 'eager', decoding: 'async' }"
                        class="w-full h-full"
                        :style="{ maxWidth: '100%', objectFit: 'contain' }" />
                </component>
            </div>

            <!-- Section: Profile -->
            <div class="xcol-span-2 flex items-center justify-end gap-x-2 w-full mr-3">
                <!-- Not Logged In -->
                <LinkIris v-if="!isLoggedIn" :href="urlLoginWithRedirect()" class="px-1" aria-label="Login icon">
                    <FontAwesomeIcon icon="fal fa-sign-in" fixed-width aria-hidden="true"
                        :style="getStyles(headerData?.mobile?.profile?.container?.properties, screenType)"
                        class="text-3xl"
                    />
                </LinkIris>

                <!-- Logged In -->
                <template v-else>
                    <div v-if="layout.retina?.type == 'b2b'" class="relative inline-flex">
                        <LinkIris href="/app/basket" class="px-1">
                            <FontAwesomeIcon
                                icon="fal fa-shopping-cart"
                                fixed-width
                                aria-hidden="true"
                                :style="getStyles(headerData?.mobile?.profile?.container?.properties, screenType)"
                                class="text-3xl"
                            />
                        </LinkIris>
                        <span
                            v-if="layout?.iris_variables?.cart_count"
                            class="absolute -top-1 -right-0.5 min-w-[1rem] h-4 px-1 rounded-full bg-gray-700 text-white text-[10px] leading-none flex items-center justify-center"
                        >{{ layout?.iris_variables?.cart_count }}</span>
                    </div>

                    <LinkIris href="/app/dashboard" class="px-1">
                        <FontAwesomeIcon
                            :icon="'fal fa-user-circle'"
                            fixed-width
                            aria-hidden="true"
                            class="text-3xl"
                            :style="getStyles(headerData?.mobile?.profile?.container?.properties, screenType)" />
                    </LinkIris>
                </template>
            </div>
        </div>
    </div>

</template>

<style scoped></style>